import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';
import { contactInfo } from '@/mock';
import LegalModal from './LegalModal';

const Footer = () => {
  const [isLegalModalOpen, setIsLegalModalOpen] = useState(false);

  return (
    <>
      <footer className="bg-[#0f0a0d] border-t border-rose-900/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-4xl font-script text-rose-200">LadyGo</span>
            </Link>
            <p className="text-gray-400 text-sm italic">
              L'art du transport au féminin
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-rose-200 font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-rose-200 text-sm transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-rose-200 text-sm transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/tarifs" className="text-gray-400 hover:text-rose-200 text-sm transition-colors">
                  Tarifs
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-rose-200 text-sm transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-rose-200 font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href={`tel:${contactInfo.phoneFormatted}`}
                  className="flex items-center space-x-2 text-gray-400 hover:text-rose-200 text-sm transition-colors"
                >
                  <Phone className="w-4 h-4" />
                  <span>{contactInfo.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="flex items-center space-x-2 text-gray-400 hover:text-rose-200 text-sm transition-colors"
                >
                  <Mail className="w-4 h-4" />
                  <span>{contactInfo.email}</span>
                </a>
              </li>
              <li>
                <a
                  href={`https://wa.me/${contactInfo.whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-gray-400 hover:text-rose-200 text-sm transition-colors"
                >
                  <FaWhatsapp className="w-4 h-4" />
                  <span>WhatsApp</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Zone & Info */}
          <div>
            <h3 className="text-rose-200 font-semibold mb-4">Zone d'activité</h3>
            <div className="flex items-start space-x-2 text-gray-400 text-sm mb-4">
              <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
              <div>
                <p>{contactInfo.zone}</p>
                <p className="text-xs mt-1">{contactInfo.zoneDetails}</p>
              </div>
            </div>
            <p className="text-xs text-gray-500 mt-4">
              {contactInfo.company}<br />
              Siren : {contactInfo.siren}
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-rose-900/20">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-center text-gray-500 text-sm">
              © {new Date().getFullYear()} LadyGo VTC. Tous droits réservés.
            </p>
            <div className="flex items-center gap-4">
              <button
                onClick={() => setIsLegalModalOpen(true)}
                className="text-gray-400 hover:text-rose-200 text-sm transition-colors underline"
              >
                Mentions légales
              </button>
              <span className="text-gray-600">•</span>
              <a
                href="https://marchena.fr/KEGDOUDOU/connexion.php"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-rose-200 text-sm transition-colors underline"
              >
                Admin
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>

    {/* Legal Modal */}
    <LegalModal 
      isOpen={isLegalModalOpen} 
      onClose={() => setIsLegalModalOpen(false)} 
    />
  </>
  );
};

export default Footer;